import {
  VetFormLinkData,
  // VeterinarioRes,
} from '../../../types/Reintegro/Veterinario/types';
import { ApiResponse, apiRequest } from '../../Utils/apiClient';
import {
  ADD_VETFORM_LINK_DATA,
  // GET_VETERINARIO,
  // GET_VETERINARIOS,
  // GET_VETERINARIOS_RECOMENDADOS,
  // GET_VETERINARIOS_SINIESTRO,
  // GET_VETERINARIO_VETFORM,
  GET_VETFORM,
  GET_VETFORMLINK,
  RE_SEND_VETFORM_LINK_DATA,
} from '../../Utils/constants';

const postVetFormLink = (vetFormLink: VetFormLinkData): Promise<ApiResponse<boolean>> =>
  apiRequest('post', ADD_VETFORM_LINK_DATA, vetFormLink);

const reSendVetFormLink = ({
  vetFormLinkData,
  subVetFormId,
}: {
  vetFormLinkData: VetFormLinkData;
  subVetFormId: number;
}): Promise<ApiResponse<boolean>> =>
  apiRequest('post', RE_SEND_VETFORM_LINK_DATA, {
    data: vetFormLinkData,
    subVetFormId,
  });

const getVetForm = (id: string): Promise<ApiResponse<any>> =>
  apiRequest('get', GET_VETFORM, { id });

const getVetFormLink = (ref: string): Promise<ApiResponse<any>> =>
  apiRequest('get', GET_VETFORMLINK, { ref });

// const getVeterinarios = (): Promise<ApiResponse<VeterinarioRes[]>> =>
//   apiRequest('get', GET_VETERINARIOS);

// const getVeterinarioById = (
//   veterinarioId: string,
// ): Promise<ApiResponse<VeterinarioRes>> =>
//   apiRequest('get', GET_VETERINARIO, { veterinarioId });

// const getVeterinariosBySiniestro = (
//   siniestro: string,
// ): Promise<ApiResponse<VeterinarioRes[]>> =>
//   apiRequest('get', GET_VETERINARIOS_SINIESTRO, { siniestro });

// const getVeterinarioByVetForm = (
//   vetformId: string,
// ): Promise<ApiResponse<VeterinarioRes>> =>
//   apiRequest('get', GET_VETERINARIO_VETFORM, { vetformId });

// const getVeterinariosRecomendados = (
//   id: number,
//   tipo: string,
// ): Promise<ApiResponse<VeterinarioRes[]>> =>
//   apiRequest('get', GET_VETERINARIOS_RECOMENDADOS, { id, tipo });

export {
  postVetFormLink,
  reSendVetFormLink,
  getVetForm,
  getVetFormLink,
  // getVeterinarios,
  // getVeterinarioById,
  // getVeterinariosBySiniestro,
  // getVeterinarioByVetForm,
  // getVeterinariosRecomendados,
};
